/** 临时字段存储，退出App就可以被清空 */

// ai流程ID
const aiFlowIds: string[] = [];
// ai保留的loading ID
const aiRetainLoadingIds: string[] = [];
// 中英文
const currentIsEnglish: boolean = true;

export default {
  aiFlowIds,
  aiRetainLoadingIds,
  currentIsEnglish,
};
